/* eslint-disable camelcase */
import { OptionType, SORT_ORDER, TableSortOption } from '@evinced-private/ui-common';

import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { QueryVariablesBuilder } from 'src/common/helpers/GQLRequestsHelper/QueryVariablesBuilder';
import {
	ConditionInt,
	Core_Label_IssuesSortFields,
	Core_Label_IssuesSortOrder,
	Core_Label_IssuesTextSearchFields
} from 'src/common/types/graphql.generated';

import { MobileDashboardAllIssuesQueryVariables } from '../MobileAllIssues.generated';

import { buildMobileProductOrFilter } from './mobileProductFilterBuilder';

const mobileAllIssuesSortFieldsMap: Record<string, Core_Label_IssuesSortFields> = {
	issueType: Core_Label_IssuesSortFields.TypeName,
	severity: Core_Label_IssuesSortFields.SeverityName,
	appId: Core_Label_IssuesSortFields.PageTitle,
	elementDescription: Core_Label_IssuesSortFields.PageTitle,
	foundBy: Core_Label_IssuesSortFields.ProductName,
	sessionOrTest: Core_Label_IssuesSortFields.SessionName,
	user: Core_Label_IssuesSortFields.UserName
};

const mobileAllIssuesSortOrderMap: Record<SORT_ORDER, Core_Label_IssuesSortOrder> = {
	[SORT_ORDER.ASC]: Core_Label_IssuesSortOrder.Ascending,
	[SORT_ORDER.DESC]: Core_Label_IssuesSortOrder.Descending
};

const buildDaysFilter = (dateRangeOptions?: OptionType[]): ConditionInt | undefined => {
	if (!dateRangeOptions?.length) {
		return { value: [30] };
	}

	const days = Number(dateRangeOptions[0].value);
	return Number.isNaN(days) ? { value: [30] } : { value: [days] };
};

export const buildMobileAllIssuesVariables = (
	filters: IFilterOptions,
	page: number,
	sizePerPage: number,
	sort?: TableSortOption
): MobileDashboardAllIssuesQueryVariables => {
	const variablesBuilder = new QueryVariablesBuilder<MobileDashboardAllIssuesQueryVariables>({
		sortFieldsMap: mobileAllIssuesSortFieldsMap,
		sortOrderMap: mobileAllIssuesSortOrderMap
	});

	variablesBuilder.addPaginationParams(page, sizePerPage);

	const defaultSort: TableSortOption = {
		dataField: 'issueType',
		order: SORT_ORDER.DESC
	};
	variablesBuilder.addSortParam(sort || defaultSort);

	const daysFilter = buildDaysFilter(filters.dateRange);
	if (daysFilter) {
		variablesBuilder.addConditionParam('daysFilter', daysFilter.value);
	}

	variablesBuilder
		.addFilterParam('severityFilter', filters.severities)
		.addFilterParam('issueTypeFilter', filters.types);

	if (!filters.unitId || filters.unitId.length === 0 || filters.unitId[0]?.value === '') {
		variablesBuilder.addConditionParam('businessUnitFilter', '');
	} else {
		variablesBuilder.addFilterParam('businessUnitFilter', filters.unitId);
	}

	const variables = variablesBuilder.getVariables();

	if (filters.searchValue) {
		const searchValue = filters.searchValue.toString().trim();
		if (searchValue) {
			variables.textSearch = {
				searchFields: [
					Core_Label_IssuesTextSearchFields.TypeName,
					Core_Label_IssuesTextSearchFields.Url,
					Core_Label_IssuesTextSearchFields.PageTitle,
					Core_Label_IssuesTextSearchFields.SessionName
				],
				searchValues: [searchValue],
				insensitive: true
			};
		}
	}

	return {
		...variables,
		mobileProductOrFilter: buildMobileProductOrFilter()
	};
};
